/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    cov: {
        id: 'quoteandbind.PPLProLinedirectives.templates.ScopeofServices.Coverages',
        defaultMessage: 'Coverages'
    },
    form:{
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Endorsements',
        defaultMessage: 'Endorsements'
    },
    totalInsValue: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Information.Total Insured Value',
        defaultMessage: 'Total Insured Value : '
    }

});